/**
 * OAuth callback detection utilities
 */

/**
 * Check if current URL has OAuth callback parameters (in hash OR query string)
 */
export function hasOAuthParams(): boolean {
  const hash = globalThis.location.hash;
  const search = globalThis.location.search;
  return (
    (hash.includes('state=') || search.includes('state=')) &&
    (hash.includes('code=') ||
      search.includes('code=') ||
      hash.includes('error=') ||
      search.includes('error='))
  );
}

/**
 * Clear OAuth parameters from the URL hash
 */
export function clearOAuthParamsFromUrl(): void {
  if (globalThis.location.hash.includes('state=')) {
    globalThis.history.replaceState(
      null,
      '',
      globalThis.location.pathname + globalThis.location.search
    );
  }
}
